import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconSave = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3 3.9C3 3.40294 3.40294 3 3.9 3H17.062C17.2808 3 17.492 3.07967 17.6563 3.22411L20.6943 5.89526C20.8886 6.06613 21 6.31238 21 6.57115V20.1C21 20.5971 20.5971 21 20.1 21H3.9C3.40294 21 3 20.5971 3 20.1V3.9Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.78509 3V7.41653H16.2116V3M20.6943 5.89526L17.6563 3.22411C17.492 3.07967 17.2808 3 17.062 3H3.9C3.40294 3 3 3.40294 3 3.9V20.1C3 20.5971 3.40294 21 3.9 21H20.1C20.5971 21 21 20.5971 21 20.1V6.57115C21 6.31238 20.8886 6.06613 20.6943 5.89526Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.0056,
  cy: 13.5419,
  r: 2.75751,
  fill: "none",
  stroke: "black",
  strokeWidth: 1.5
}));
export { IconSave };